import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { BOX_IMAGE, BOX_IMAGE_ALT } from '../data/content';
export function Hero() {
  return <header className="flex min-h-[100svh] w-full flex-col justify-start bg-slate-950 px-4 pb-6 pt-5 text-white sm:justify-center sm:px-5 sm:py-12" data-id="element-79" data-mp="9kjx0ppbh647">
      <div className="mx-auto flex w-full max-w-[1000px] flex-col items-center text-center" data-id="element-80" data-mp="4na0yr7f9w7e">
        <h1 className="text-balance text-[clamp(1.45rem,6vw,4rem)] font-black uppercase leading-[0.95] tracking-tight text-white" data-id="element-81" data-mp="1285x3nzc5smb">
          The Complete Visual System{' '}
          <span className="text-orange-500" data-id="element-82" data-mp="sai2qz5n6n4o">
            for Anatomy & Physiology Teachers
          </span>
        </h1>

        <p className="mt-2.5 inline-block text-balance rounded-md bg-slate-900 px-3 py-1.5 text-[clamp(0.75rem,2.4vw,1.35rem)] sm:mt-4 sm:py-2 font-extrabold uppercase leading-tight tracking-tight text-white ring-1 ring-orange-500/40 sm:px-6" data-id="element-83" data-mp="nbeyhgxhkkxr">
          Stop searching.{' '}
          <span className="text-orange-500" data-id="element-84" data-mp="3j895n7fl21mw">
            Start teaching with everything organized.
          </span>
        </p>

        <p className="mt-2.5 max-w-[780px] text-[clamp(0.8rem,2.1vw,1.15rem)] leading-snug text-white/80 sm:mt-5 sm:leading-relaxed" data-id="element-85" data-mp="3o73o289n1o6h">
          Everything you need to teach Anatomy & Physiology, explain key
          concepts visually, use ready-to-print classroom materials, assess
          student understanding, and organize the school year—
          <strong className="font-extrabold text-white" data-id="element-86" data-mp="358hleoyh3p0g">
            in one complete visual teaching system.
          </strong>
        </p>

        <p className="mt-3 hidden max-w-[780px] text-[clamp(0.92rem,2.1vw,1.15rem)] leading-relaxed text-white/80 sm:block" data-id="element-87" data-mp="2ql6ampa4891e">
          Spend less time jumping between scattered resources and build a
          clearer way to teach, review, practice, and assess Anatomy &
          Physiology throughout the school year.
        </p>

        <img src={BOX_IMAGE} alt={BOX_IMAGE_ALT} className="mt-3 max-h-[42svh] w-auto max-w-full object-contain sm:mt-6 sm:max-h-[64svh]" width={1240} height={1240} data-id="element-88" data-mp="2lmuzmb833shl" />

        <CtaButton label="Yes! I want my complete teaching system now" size="compact" href="#offer" className="mt-3 w-full max-w-[460px] sm:mt-6" data-id="element-89" data-mp="ibyrmia3nc4t" />

        <p className="mt-2 flex sm:mt-3 items-center gap-1.5 text-[clamp(0.7rem,2vw,0.85rem)] font-bold uppercase tracking-wide text-white" data-id="element-90" data-mp="1b0vzrskljsju">
          <ShieldCheckIcon className="h-4 w-4 shrink-0 text-orange-500" aria-hidden="true" data-id="element-91" data-mp="163472wc4o2el" />
          7-Day Money-Back Guarantee — Zero Risk
        </p>
      </div>
    </header>;
}